
export function looksLikeAddress(input) {
  const ethAddress = /^0x[a-fA-F0-9]{40}$/;
  const btcAddress = /^(bc1([a-zA-HJ-NP-Z0-9]{6,87})|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;
  const tronAddress = /^T[a-zA-Z0-9]{33}$/;

  return ethAddress.test(input) || btcAddress.test(input) || tronAddress.test(input);
} 
export function isValidAddress(address) {
        const patterns = {
            'Ethereum': /^0x[a-fA-F0-9]{40}$/,
            'Bitcoin': /^(bc1([a-zA-HJ-NP-Z0-9]{6,87})|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/,
            'Tron': /^T[a-zA-Z0-9]{33}$/
        };
           function  detectNetwork(address) {
        if (address.startsWith('0x') && address.length === 42) {
            return 'Ethereum';
        } else if ((address.startsWith('bc1') && address.length >= 14 && address.length <= 62) || 
                   ((address.startsWith('1') || address.startsWith('3')) && address.length >= 26 && address.length <= 35)) {
            return 'Bitcoin';
        } else if (address.startsWith('T') && address.length === 34) {
            return 'Tron';
        }
        return null;
    }

        const network = detectNetwork(address);
        if (!network) return false; // If the network isn't detected, return false
        return patterns[network].test(address);
    }

 export function validateTransactionHash(hash) {
      const ethereumPattern = /^0x[a-fA-F0-9]{64}$/;
      const bitcoinPattern = /^[a-fA-F0-9]{64}$/;
      const tronPattern = /^T[a-zA-Z0-9]{33}$/;

      if (ethereumPattern.test(hash)) return 'Ethereum';
      if (bitcoinPattern.test(hash)) return 'Bitcoin';
      if (tronPattern.test(hash)) return 'Tron';
      return null;
    }
export function looksLikeAddressOrWrongInput(input) {
  const trimmed = input.trim();

  // Obvious address patterns
  const ethAddress = /^0x[a-fA-F0-9]{40}$/;
  const btcAddress = /^(bc1([a-zA-HJ-NP-Z0-9]{6,87})|[13][a-km-zA-HJ-NP-Z1-9]{25,34})$/;
  const tronAddress = /^T[a-zA-Z0-9]{33}$/;

  // Explorer URL patterns (Etherscan, Tronscan, Blockchain.com, etc.)
  const explorerURL = /(etherscan\.io|tronscan\.org|blockchain\.com|bscscan\.com)\/(tx|address)\/[a-zA-Z0-9]+/;

  // Too short to be valid
  const tooShort = trimmed.length < 40;

  // Contains whitespace or newline
  const hasWhitespace = /\s/.test(trimmed);

  return (
    ethAddress.test(trimmed) ||
    btcAddress.test(trimmed) ||
    tronAddress.test(trimmed) ||
    explorerURL.test(trimmed) ||
    tooShort ||
    hasWhitespace
  );
}
